const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/intlReducer.ts';
import Imm from 'immutable';
import moment from 'moment';
import { atSetI18nLocaleSuccess, SetI18nLocaleSuccessAction } from '../actions/intlActions';
import { DEFAULT_LOCALE, intlLanguagesMap } from '../utils/intlUtils';
import { Logger } from '../services/KisLoggerService';

const Log = Logger('intlReducer');

const initialState = Imm.Map({
    locale: DEFAULT_LOCALE,
});

export const intlReducer = (state: any = initialState, action: any = {}) => {
    switch (action.type) {
        case atSetI18nLocaleSuccess:
            return handleSetI18nLocaleSuccess(state, action);
        default:
            return state;
    }
};

function handleSetI18nLocaleSuccess(state: any, action: SetI18nLocaleSuccessAction) {
    const prevLocale = state.get('locale') || DEFAULT_LOCALE;

    if (action.dictionary) {
        if (prevLocale !== DEFAULT_LOCALE) {
            delete intlLanguagesMap[prevLocale]; // throw away the texts of the previous locale
        }
        intlLanguagesMap[action.meta.locale] = action.dictionary;
    } else {
        // The dictionary is null when we're switching back to the DEFAULT_LOCALE, otherwise it's an error.
        if (action.meta.locale !== DEFAULT_LOCALE) {
            Log.error(`Dictionary required when switching to locale ${action.meta.locale}`);
            return state;
        }
    }

    moment.locale([action.meta.locale, DEFAULT_LOCALE]);
    return state.set('locale', action.meta.locale);
}
